import { useTranslation } from "react-i18next";

const CompletedIcon = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
  >
    <path
      d="M8.333 10.75l3.3-3.3a.64.64 0 01.467-.183.64.64 0 01.467.183.64.64 0 01.183.467.64.64 0 01-.183.467L8.8 12.15a.645.645 0 01-.467.2.645.645 0 01-.467-.2l-1.9-1.9a.64.64 0 01-.183-.467.64.64 0 01.183-.467.64.64 0 01.467-.183.64.64 0 01.467.183l1.433 1.434zM1.333 13.333A1.29 1.29 0 01.392 12.942 1.29 1.29 0 010 12V2.667c0-.367.13-.681.392-.942.261-.261.575-.392.941-.392h2.784a1.58 1.58 0 01.716-.958A1.82 1.82 0 016 0c.444 0 .842.125 1.192.375.35.25.586.569.708.958h2.767c.366 0 .68.13.941.392.261.261.392.575.392.942V5.333a.644.644 0 01-.192.475.644.644 0 01-.475.192.644.644 0 01-.475-.192.644.644 0 01-.191-.475V2.667H9.333V4c0 .189-.064.347-.192.475a.644.644 0 01-.474.192H3.333a.644.644 0 01-.475-.192.644.644 0 01-.191-.475V2.667H1.333V12h3.334c.188 0 .347.064.475.192a.644.644 0 01.191.475.644.644 0 01-.191.475.644.644 0 01-.475.191H1.333zM6 2.667c.189 0 .347-.064.475-.192A.644.644 0 006.667 2a.644.644 0 00-.192-.475A.644.644 0 006 1.333a.644.644 0 00-.475.192.644.644 0 00-.192.475c0 .189.064.347.192.475.128.128.286.192.475.192z"
      fill="currentColor"
    />
  </svg>
);

const InProgressIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
  >
    <path
      d="M3.333 12.667H4.283L10.8 6.15 9.85 5.2 3.333 11.717v.95ZM2 14v-2.833l8.8-8.784c.133-.122.281-.217.442-.283a1.42 1.42 0 01.508-.1c.178 0 .35.033.517.1.166.067.311.167.433.3l.917.933c.133.123.23.267.291.434.061.166.092.333.092.5 0 .178-.031.347-.092.508a1.147 1.147 0 01-.291.442L4.833 14H2Zm8.317-8.317-.467-.483.95.95-.483-.467Z"
      fill="currentColor"
    />
  </svg>
);

const ScheduledIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
  >
    <path
      d="M6.519 13.333c-1.578 0-2.97-.483-4.175-1.45-1.206-.966-1.98-2.2-2.325-3.7a.634.634 0 01.1-.508.627.627 0 01.45-.258.628.628 0 01.5.133c.144.111.244.261.3.45.3 1.167.925 2.125 1.875 2.875s2.091 1.125 3.325 1.125c1.489 0 2.75-.517 3.783-1.55 1.034-1.033 1.55-2.294 1.55-3.783 0-1.49-.516-2.75-1.55-3.784C9.269 1.85 8.008 1.333 6.519 1.333c-.956 0-1.842.236-2.658.708-.817.473-1.464 1.125-1.942 1.959h1.267c.189 0 .347.064.475.192a.644.644 0 01.192.475.644.644 0 01-.192.475.644.644 0 01-.475.191H.919a.597.597 0 01-.583-.291.558.558 0 01-.1-.625c.466-1.311 1.272-2.375 2.416-3.192C3.797.408 5.086 0 6.519 0a6.75 6.75 0 012.6.525c.811.35 1.517.825 2.117 1.425.6.6 1.075 1.306 1.425 2.117.35.81.525 1.678.525 2.6 0 .922-.175 1.789-.525 2.6-.35.811-.825 1.517-1.425 2.117-.6.6-1.306 1.075-2.117 1.425-.81.35-1.678.524-2.6.524zm.667-6.933l1.666 1.667a.64.64 0 01.184.466.64.64 0 01-.184.467.64.64 0 01-.466.183.64.64 0 01-.467-.183L6.052 7.133a.585.585 0 01-.15-.225.692.692 0 01-.05-.258V4a.644.644 0 01.192-.475.644.644 0 01.475-.192c.189 0 .347.064.475.192A.644.644 0 017.186 4v2.4z"
      fill="currentColor"
    />
  </svg>
);

const STATUS_VARIANTS = {
  Scheduled: {
    badgeClass: "campaign-status-badge--scheduled",
    customIcon: ScheduledIcon,
  },
  InProgress: {
    badgeClass: "campaign-status-badge--in-progress",
    customIcon: InProgressIcon,
  },
  Completed: {
    badgeClass: "campaign-status-badge--completed",
    customIcon: CompletedIcon,
  },
};

const CampaignStatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const variant = STATUS_VARIANTS[status] ?? {
    badgeClass: "char-badge-outline",
    customIcon: null,
  };
  return (
    <span className={`char-badge ${variant.badgeClass}`}>
      {variant.customIcon && <variant.customIcon />}
      {t(status)}
    </span>
  );
};

export default CampaignStatusBadge;
